import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { AuthorizationService } from '../core/authorization.service';
import { ReadinessService } from '../core/readiness.service';

@Component({
  selector: 'app-redirect',
  template: '',
  standalone: false,
})
export class RedirectComponent implements OnInit {
  constructor(
    private auth: AuthService,
    private authorization: AuthorizationService,
    private readiness: ReadinessService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.readiness.checkReadiness().subscribe({
      next: (ready) => {
        if (!ready) {
          this.router.navigateByUrl('/service-unavailable', { replaceUrl: true });
          return;
        }
        this.auth.ensureSession().subscribe({
          next: (hasSession) => {
            const target = hasSession ? this.authorization.getHomeRoute() : '/login';
            this.router.navigateByUrl(target, { replaceUrl: true });
          },
          error: () => {
            this.router.navigateByUrl('/login', { replaceUrl: true });
          },
        });
      },
      error: () => {
        this.router.navigateByUrl('/service-unavailable', { replaceUrl: true });
      },
    });
  }
}
